export const windowWidth = $(window).width();

export const mobileMatch = window.matchMedia("(max-width: 768px)");

export const collapsTowns = (aq1, aq2,aq3,aq4,aq5,aq6) => {
    if (!mobileMatch.matches) {
        var moreText = $(aq6).text();
        var sectionWidth = $(aq1).width();
        var windowWidth = 0;
        if ($('#list_page').length > 0) {
            windowWidth += sectionWidth - (2 * $('#list_page #city_tabs .city_tabs_wrapper .name_tab').width());
        } else {
            windowWidth += sectionWidth;
        }
        var tabsWidth = $(aq2).width();
        var numberOfTabs = $(aq3);
        var newTabsWrap = $(aq4);
        var hiddenTabs = $(aq5);
        var pointer = 0;
        while (windowWidth < (tabsWidth + 30)) {
            $(aq6).css({'opacity': '1', 'pointer-events': 'auto', 'display': 'inline-block'});
            var elementBufer = $(numberOfTabs[numberOfTabs.length-(2+pointer)]);
            var clonedElement = $(elementBufer).clone();
            $(newTabsWrap).prepend(clonedElement);
            $(elementBufer).remove();
            tabsWidth = $(aq2).width();
            // numberOfTabs--;
            pointer++;
            hiddenTabs = $(newTabsWrap).find('div');
        }
        var firstHiddenTown = hiddenTabs[0];
        var abstractWidth = tabsWidth + $(firstHiddenTown).find('a').width() + 45;
        if ($(hiddenTabs).length >= 1) {
            while (windowWidth > abstractWidth) {
                var elementFromHidden = $(firstHiddenTown).clone();
                $(firstHiddenTown).remove();
                $(aq6).before(elementFromHidden);
                tabsWidth = $(aq2).width();
                hiddenTabs = $(newTabsWrap).find('div');
                firstHiddenTown = hiddenTabs[0];
                abstractWidth = tabsWidth + $(firstHiddenTown).find('a').width() + 30;
                if (firstHiddenTown == undefined) {
                    $(aq6).css({'opacity': '0', 'pointer-events': 'none', 'display': 'none'});
                    // $(aq4).css('visibility','hidden');
                    break;
                }
            }
        } else {
            $(aq6).css({'opacity': '0', 'pointer-events': 'none', 'display': 'none'});
            // $(aq4).css('visibility','hidden');
        }
        if ($(aq4).find('.active').length === 1) {
            $(aq6).text($(aq2).find('.active').text());
            $(aq6).addClass('down_tab');
            console.log($(aq2).find('.active').text());
        } else {
            $(aq6).removeClass('down_tab');
            $(aq6).text(moreText);
            // console.log(moreText);
        }
    }
};

export const smoothScrollToTarget = (e) => {
    let to = e.target.getAttribute('data-to');
    $('html, body').animate({
        scrollTop: $(to).offset().top
    }, 500);
};

export const masterModel = (n) => {
    function defy() {
        if (n !== undefined) {
            if ($('#pers_tab_'+ n +' #master_'+ n).hasClass('active')) {
                $('#content_'+ n +' .model_info, #content_'+ n +' .hurryUp_model, #content_' + n + ' .icons_section.model, #content_'+ n +' .form-price.model, #content_'+ n +' #model_social_' + n + ', #content_'+ n +' #model_time').addClass('hide');
                $('#content_'+ n +' .master_info, #content_'+ n + ' .hurryUp_master, #content_' + n + ' .icons_section.master, #content_'+ n +' .form-price.master, #content_'+ n +' #manager_' + n +', #bf-' + n).removeClass('hide');
            }
            if ($('#pers_tab_'+ n +' #model_'+ n).hasClass('active')) {
                $('#content_'+ n +' .master_info, #content_'+ n +' .hurryUp_master, #content_' + n + ' .icons_section.master, #content_'+ n +' .form-price.master, #content_'+ n +' #manager_' + n +', #bf-' + n).addClass('hide');
                $('#content_'+ n +' .model_info, #content_'+ n + ' .hurryUp_model, #content_' + n + ' .icons_section.model, #content_'+ n +' .form-price.model, #content_'+ n +' #model_social_' + n + ', #content_'+ n +' #model_time').removeClass('hide');
            }
        } else {

        }
    }
    defy();
    $('.person_tabs.enabled .pers_tab').on('click', function () {
        // console.log(n);
        $('.person_tabs.enabled .pers_tab').removeClass('active');
        $(this).addClass('active');
        if ($(this).attr('id') == 'master_' + n) {
            $('#content_'+ n +' .check_person select').find('option').removeAttr('selected').filter('[value^=master]').attr('selected', true);
            $('#content_'+ n +' .two_steps .go_form').addClass('hide');
            $('#content_'+ n +' .two_steps .go_send_form').removeClass('hide');


        } else if ($(this).attr('id') == 'model_' + n) {
            $('#content_'+ n +' .check_person select').find('option').removeAttr('selected').filter('[value^=model]').attr('selected', true);
            $('#content_' + n + ' .two_steps .go_form').removeClass('hide');
            $('#content_' + n + ' .two_steps .go_send_form').addClass('hide');
        }
        defy();
    });

    $('#content_'+ n +' select[id^="type_person"]').on('change', function () {
        let selectedTypeMaster = $(this).find('option').filter('[value^=master]');
        let selectedTypeModel = $(this).find('option').filter('[value^=model]');
        if ($(selectedTypeMaster).is(':selected')) {
            $('#content_'+ n +' select[id^="type_person"]').find('option').removeAttr('selected').filter('[value^=master]').attr('selected', true);
            $('.person_tabs.enabled .pers_tab').removeClass('active');
            $('.person_tabs.enabled #master_' + n).addClass('active');
        }
        else if ($(selectedTypeModel).is(':selected')) {
            $('#content_'+ n +' select[id^="type_person"]').find('option').removeAttr('selected').filter('[value^=model]').attr('selected', true);
            $('.person_tabs.enabled .pers_tab').removeClass('active');
            $('.person_tabs.enabled #model_' + n).addClass('active');
        }
        defy();
    });
    $('#tabs_p_'+ n).on('change', function () {
        let selectedTypeMaster = $(this).find('option').filter('[value^=master]');
        let selectedTypeModel = $(this).find('option').filter('[value^=model]');
        if ($(selectedTypeMaster).is(':selected')) {
            $('#tabs_p_'+ n).find('option').removeAttr('selected').filter('[value^=master]').attr('selected', true);
            $('.person_tabs.enabled .pers_tab').removeClass('active');
            $('.person_tabs.enabled #master_' + n).addClass('active');
        }
        else if ($(selectedTypeModel).is(':selected')) {
            $('#tabs_p_'+ n).find('option').removeAttr('selected').filter('[value^=model]').attr('selected', true);
            $('.person_tabs.enabled .pers_tab').removeClass('active');
            $('.person_tabs.enabled #model_' + n).addClass('active');
        }
        defy();
    });
};

export const notUndefined = (elm) => {
    return typeof elm !== "undefined";
};

export const getChildNumber = (node) => {
    return Array.prototype.indexOf.call(node.parentNode.childNodes, node);
};

export const makeRequest = (method, url, body) => {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send(body);
    });
};